import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Landing from "./pages/Landing";
import Main from "./pages/Main";
import MainHome from "./pages/MainHome";
import About from "./pages/About";
import Gallery from "./pages/Gallery";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/main" element={<Main />}>
          <Route index element={<MainHome />} /> {/* /main */}
          <Route path="about" element={<About />} /> {/* /main/about */}
          <Route path="gallery" element={<Gallery />} /> {/* /main/gallery */}
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
